<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Uxpg5D/tc-custom/9780802192219.jpg?1705549508318" alt="This image is the cover for the book Legends of the Fall"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Legends of the Fall
      </h1>
      <p class="bookDescription body article font2">
        <b>Three novellas by the <i>New York Times</i> bestselling author, including the classic tale of brotherhood from the Montana plains through the horrors of WWI.</b><br/>  <br/> Jim Harrison’s critically acclaimed novella “Legends of the Fall”—which was made into the film of the same name—is an epic tale of three brothers fighting for justice in a world gone mad. Moving from the expansive landscape of early twentieth-century Montana to the blood-drenched battlefields of World War I Europe, Harrison explores the desperate actions of which men are capable when their lives or aspirations are threatened.<br/> Also including the novellas “Revenge” and “The Man Who Gave Up His Name,” <i>Legends of the Fall</i> confirms Jim Harrison’s reputation as a writer who “stands high among the writers of his generation. This book is rich, alive, and shatteringly visceral. A triumph” (<i>New Yorker</i>).<br/>  <br/><b>“I can’t begin to do justice to the nuances of character and honest complexities of plot in this work. The writing is precise and careful—and sings withal.” —Raymond Carver, <i>Washington Post Book World</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jim Harrison
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Grove Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3e49d9c7